import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Checkbox,
  Flex,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { memo, useCallback } from "react";
import { useAtom } from "jotai/index";

import { getCurrentColor } from "../../constants";
import {
  categoriesPageModeAtom,
  selectedFiltersAtom,
} from "../../atom/listings";
import { selectedFiltersAtom as productsSelectedFiltersAtom } from "../../atom/products";
import useFilter from "../../hooks/useFilter";

// Single-checkbox condition filter shown inside the same dropdown shell as the
// other filters. Unchecked => "New" only, Checked => "New,Used".
const ConditionFilter = () => {
  const { colorMode } = useColorMode();
  const [categoriesPageMode] = useAtom(categoriesPageModeAtom);
  const isListingsMode = categoriesPageMode === "listings";
  const [selectedFilters] = useAtom(
    isListingsMode ? selectedFiltersAtom : productsSelectedFiltersAtom,
  );
  const { AddOrUpdateFilter } = useFilter();

  const isChecked = (selectedFilters?.["condition"] ?? []).some(
    (item) => (item.flag || item.value) + "" === "Used",
  );

  const handleChange = useCallback(() => {
    // "New" is always present; the checkbox only toggles "Used".
    if (isChecked) {
      AddOrUpdateFilter("condition", "Used", "remove");
      AddOrUpdateFilter("condition", "New", "add");
    } else {
      AddOrUpdateFilter("condition", "New", "add");
      AddOrUpdateFilter("condition", "Used", "add");
    }
  }, [isChecked, AddOrUpdateFilter]);

  return (
    <Flex w={"100%"}>
      <Accordion allowMultiple w={"100%"} defaultIndex={[0]}>
        <AccordionItem
          w={"100%"}
          borderRadius={{ base: "0px", lg: "6px" }}
          border={{ base: "none", lg: "1px solid" }}
          height={"100%"}
          borderColor={getCurrentColor(
            colorMode,
            "grayC.500 !important",
            "transparent !important",
          )}
          _hover={{ bg: getCurrentColor(colorMode, "grayC.600", "grayC.1700") }}
        >
          <AccordionButton
            bg={getCurrentColor(colorMode, "grayC.600", "grayC.1700")}
            borderTopRadius={{ base: "0px", lg: "6px" }}
          >
            <Box
              as="span"
              flex="1"
              color={getCurrentColor(colorMode, "black.200", "grayC.1600")}
              textAlign="left"
            >
              Condition
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel
            pt={{ base: "10px", md: "10px" }}
            pb={4}
            pr={3}
            w={"100%"}
            bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1900")}
            borderBottomRadius={{ base: "0px", lg: "6px" }}
          >
            <Checkbox
              isChecked={isChecked}
              onChange={handleChange}
              alignItems={"flex-start"}
              gap={"8px"}
              cursor={"pointer"}
              sx={{
                ".chakra-checkbox__control": { cursor: "pointer", mt: "2px" },
                ".chakra-checkbox__label": { width: "100%" },
                ".chakra-checkbox__label > *": { cursor: "pointer" },
              }}
            >
              <Text
                fontSize={"xs"}
                fontFamily={"mainFont"}
                fontWeight={"400"}
                color={getCurrentColor(colorMode, "grayC.1900", "grayC.1600")}
              >
                Display Seconds / Surplus / Reman
              </Text>
            </Checkbox>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  );
};

export default memo(ConditionFilter);
